//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ObjectSnippet from "@/components/objects/ObjectSnippet.vue";
import { STORAGE_IMAGE_PATH } from "@/constants/ui.js";
import { trackHit } from "@/utils/helpers.js";

const PER_PAGE = 12

export default {
  name: "ArtList",
  components: { ObjectSnippet },
  layout: "public_new",
  async asyncData({ store, query }) {
    const page = 0
    const objects = await store.dispatch('art/publicObjects', {
      ...query,
      limit: PER_PAGE,
      offset: page * PER_PAGE,
      category: query.category || null,
      order: '-total_score',
    })

    await store.dispatch('art/fetchMaterialCategories')

    return {
      objects: objects.items,
      page: page,
      categories: await store.dispatch('categories/getNavTree')
    }
  },
  data() {
    return {
      objects: [],
      per_page: PER_PAGE,
      page: 0,
      imagePath: [`${STORAGE_IMAGE_PATH}$id`, 'cover'],
      categories: [],
      selectedCategory: null,
      headTitle: 'Мои материалы'
    }
  },
  async fetch() {
    this.page = 0
    this.$store.dispatch('art/publicObjects', {
      ...this.$route.query,
      limit: PER_PAGE,
      offset: this.page * PER_PAGE,
      category: this.$route.query.category,
      order: '-total_score',
    }).then(response => {
      this.objects = response.items
    })
  },
  head() {
    return {
      title: this.headTitle
    }
  },
  watch: {
    '$route.query': '$fetch'
  },
  async mounted() {
    this.selectedCategory = this.$route.query.category ?? null
    trackHit(this.$route.fullPath, this.headTitle, this.$route.meta.referer)
  },
  methods: {
    infiniteScroll($state) {
      this.page++;
      this.$store.dispatch('art/publicObjects', {
        ...this.$route.query,
        limit: PER_PAGE,
        offset: this.page * PER_PAGE,
        category: this.$route.query.category,
        order: '-total_score',
      })
        .then(response => {
          if (response.items.length) {
            response.items.forEach(x => {
              this.objects.push(x)
            })

            $state.loaded()
          } else {
            $state.complete()
          }

        })
        .finally(() => {

        })
    },
    handleCategoriesFilter(categoryUrl) {
      if (this.selectedCategory === categoryUrl) {
        this.selectedCategory = null;
      } else {
        this.selectedCategory = categoryUrl;
      }
      this.$router.push({ query: categoryUrl ? { category: categoryUrl } : {} })
    }
  }
}
